module.exports = __webpack_public_path__ + "static/img/cooperative_partner_3.8c8b017.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperative_partner_3.png
// module id = pjsQ
// module chunks = 0